import { DeleteOutlined, PlusOutlined, EditOutlined, SaveOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Row, Space, Table } from 'antd';
import Column from 'antd/es/table/Column';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Links } from '../../helpers/Links';
import { menuHelper } from '../../helpers/account';
import { dateCommon, validateMessages } from '../../helpers/common';
import { LoiViPhamCaNhan } from '../../models/kpi/KPICaNhan';
import { ColumnsType } from 'antd/es/table';
import { layDSLoiViPhamKPICaNhan, luuLoiViPhamKPI, xoaLoiViPhamKPI } from '../../services/kpi';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import { layTenTienDoKPI, trangThaiKPI } from '../../constants';
import Link from 'antd/lib/typography/Link';
import ModalTextForm from '../../components/modal/ModalTextForm';
import { InputNumber } from 'antd/lib';
const { TextArea } = Input;

const ThongKeLoiViPham = ({ idKPI, trangThai, thangNam }: { idKPI: number, trangThai: number, thangNam: string}) => {

    const dispatch = useDispatch();
    const user = useSelector((state: any) => state.auth.currentUser);
    const menu: any = menuHelper.checkMultiPermission([Links.KPI.TongHopKPI]);
    const [loiViPhams, setLoiViPham] = useState<Array<LoiViPhamCaNhan>>([]);
    const layDuLieu = async (id: number) => {
        try {
            dispatch(showLoadingScreen());
            var data = await layDSLoiViPhamKPICaNhan(id);
                setLoiViPham(data);
        } catch (e) {
            toast.error("Không thể lấy thông tin ");
        }
        dispatch(hideLoadingScreen());
    }
    useEffect(() => {
        if (idKPI > 0) {
            layDuLieu(idKPI);
        }
    }, [idKPI])
    const [form] = Form.useForm();

    const [data, setData] = useState<LoiViPhamCaNhan | null>(null);
    const [showModalChiTiet, setShowModalChiTiet] = useState<boolean>(false);
    const [idXoa, setIdXoa] = useState<number>(0);

    const [loading, setLoading] = useState(false);
    const setFormDetailModal = (value: LoiViPhamCaNhan | null) => {
        form.setFieldsValue({
            "id": value?.id,
            "idKPI": value?.idKPI || idKPI,
            "thangNam": dateCommon.formatDate(value?.thangNam, "MM/yyyy") || thangNam,
            "noiDung": value?.noiDung || "",
            "diemTru": value?.diemTru || null,
            "ghiChu": value?.ghiChu || "",
        });
        setData(value);
        setShowModalChiTiet(true);
    }

    const columns : ColumnsType<LoiViPhamCaNhan> =  [
        {
            title: 'Thời gian',
            key: "idKPI",
            onCell: (_, index) => ({
                rowSpan: _.rowSpan ,
            }),
            render: (value: any, record: LoiViPhamCaNhan, index: number) => {
                return "Tháng " + dateCommon.formatDate(record.thangNam, "MM/yyyy");
            },
        },
        {
            title: 'Nội dung',
            key: "noiDung",
            onCell: (_, index) => ({
                rowSpan: 1 ,
            }),
            dataIndex: 'noiDung',
        },
        {
            title: 'Điểm trừ',
            className: 'text-center',
            dataIndex: 'diemTru',
            onCell: (_, index) => ({
                rowSpan: 1 ,
            }),
            key: "diemTru",
        },
        {
            title: 'Ghi chú',
            dataIndex: 'ghiChu',
            onCell: (_, index) => ({
                rowSpan: 1 ,
            }),
            key: "ghiChu",
        },
        ...(menu?.[Links.KPI.TongHopKPI]
            ? [
                {
                    title: '',
                    dataIndex: 'id',
                    key: 'action',
                    width: "180px",
                    render: (_: any, record: LoiViPhamCaNhan) => {
                        return (
                            <Space>
                                <Button
                                    type="primary"
                                    icon={<EditOutlined rev="" />}
                                    size="small"
                                    onClick={() => setFormDetailModal(record)}
                                >
                                    Sửa
                                </Button>

                                <Button
                                    type="primary"
                                    icon={<DeleteOutlined rev="" />}
                                    size="small"
                                    danger
                                    onClick={() => setIdXoa(record.id)}
                                >
                                    Xóa
                                </Button>
                            </Space>
                        );
                    },
                },
            ]
            : []),
    ];

    const onFinish = async (values: any) => {
        try {
            setLoading(true);
            await luuLoiViPhamKPI(values);
            toast.success('Lưu thông tin lỗi vi phạm thành công!');
            setShowModalChiTiet(false);
        }
        catch (err: any) {
            setShowModalChiTiet(false);
            toast.error('Đã xảy ra lỗi, lưu không thành công!');
        }
        setLoading(false);
        layDuLieu(idKPI);
    }

    const onDelete = async () => {
        try {
            setLoading(true);
            await xoaLoiViPhamKPI(idXoa);
            toast.success('Xoá thông tin lỗi vi phạm thành công!');
        }
        catch (err: any) {
            toast.error('Đã xảy ra lỗi, xoá không thành công!');
        }
        setIdXoa(0);
        setLoading(false);
        layDuLieu(idKPI);
    }
    return (<>
        {idXoa > 0 &&
            <ModalTextForm show={idXoa > 0}
                title="Xoá thông tin lỗi vi phạm"
                handleClose={() => setIdXoa(0)}
                handleSave={onDelete}>
                Xác nhận xóa thông tin lỗi vi phạm đang chọn
            </ModalTextForm> 
        }
        <Row>
            <Col span="24" className="card card-body">
                <Row gutter={16}>
                    <Col span={12}>
                        <label>Thống kê lỗi vi phạm tổng hợp</label>
                    </Col>
                    {
                        trangThai == trangThaiKPI.pheDuyet && menu[Links.KPI.TongHopKPI] &&
                        <Col span={12} style={{ marginBottom:"15px" }}>
                            <Space className="float-right">
                                <Link
                                    className="hrm-btn hrm-btn-warning"
                                        onClick={() => {
                                            setFormDetailModal(null);
                                    }}                       >
                                    <PlusOutlined rev="" /> Thêm mới
                                </Link>
                            </Space>
                        </Col>
                    }
                </Row>
                <Row>
                    <Col span={24}>
                        <Table
                            locale={{ emptyText: "Không có dữ liệu" }}
                            columns={columns}
                            dataSource={(loiViPhams || []).map((value, index) => { const item = { key: value.id, ...value }; return item; })}
                            pagination={false}
                            bordered
                            rowClassName={(record, index) => {
                                return (record?.id === idXoa) ? "selected-row row-key-" : "";
                            }}
                        >
                        </Table>
                    </Col>
                </Row>
            </Col>
        </Row>

        {showModalChiTiet && <ModalTextForm title="Quản lý lỗi vi phạm"
            hideFooter
            show={showModalChiTiet}
            handleClose={() => setShowModalChiTiet(false)}
        >
            < Form
                layout="vertical"
                validateMessages={validateMessages}
                onFinish={onFinish}
                form={form}
            >
                <Form.Item hidden name="id"><Input /></Form.Item>
                <Form.Item hidden name="idKPI"><Input /></Form.Item>

                <label>Thời gian: {form.getFieldValue("thangNam")}</label>
                <Row>
                    <Col span={24}>
                        <Form.Item name="noiDung" label="Nội dung" required>
                            <TextArea rows={4} placeholder="Nội dung" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={18}>
                        <Form.Item name="ghiChu" label="Ghi chú">
                            <TextArea rows={4} placeholder="Ghi chú" />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item name="diemTru" label="Điểm trừ">
                            <InputNumber style={{ width: "100%" }} />
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item>
                    <Button type="primary" className="float-right" htmlType="submit" loading={loading} icon=<SaveOutlined rev="" />>
                        Lưu
                    </Button>
                </Form.Item>
            </Form>
        </ModalTextForm>
            }
        </>
    );
};

export default ThongKeLoiViPham;
